import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";

export const AuthRoute = () => {
	const { currentUser }: { currentUser: any } = useContext(AuthContext);
	return !currentUser ? <Outlet /> : <Navigate to="/dashboard" />;
};
